export const msalConfig = {
    auth: {
        clientId: "ccf57d20-4a7a-4049-bcde-9d1ee9e47add",
        authority: "https://login.microsoftonline.com/cf9e41df-2512-4da9-a4ab-c349663c0e26",
        redirectUri: window.location.origin
    }
};

export const loginRequest = {
    scopes: ["User.Read"]
};